<div *ngIf="this.mapQueryClick && feature.properties" class="container">
  <div class="query-content">
    <p class="igo-panel-title">
      {{
        ('sideResult.title.immeuble' | translate) +
          ' ' +
          feature.properties.numero_immeuble
      }}
    </p>
    <div *ngIf="feature.properties.nom_immeuble" class="attribute">
      <p class="attribute-label">
        {{ 'sideResult.nom_immeuble' | translate }} :&nbsp;
      </p>
      <p class="attribute-value">{{ feature.properties.nom_immeuble }}</p>
    </div>
    <div class="attribute">
      <p class="attribute-label">
        {{ 'sideResult.adresse_immeuble' | translate }} :&nbsp;
      </p>
      <p class="attribute-value-address">{{ formatAddress() }}</p>
    </div>
    <div class="attribute">
      <p class="attribute-label">
        {{ 'sideResult.vocation_officielle' | translate }} :&nbsp;
      </p>
      <p class="attribute-value">
        {{ feature.properties.vocation_officielle }}
      </p>
    </div>

    <div
      class="wrapper"
      [routerLink]="[
        '/',
        'liste',
        feature.properties.numero_immeuble.substr(
          0,
          feature.properties.numero_immeuble.indexOf('-')
        )
      ]"
    >
      {{ 'sideResult.building_link' | translate }}
    </div>
  </div>
</div>
